import { doc, getDoc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '@/services/firebase';

export type UserDoc = {
  email: string;
  firstName: string;
  lastName: string;
  mdType: string;
  billingAgency: string;
  billingEmail: string;
  mainPlace: string;
  secondaryPlace: string;
  billingType: string;
  createdAt?: unknown;
};

const userRef = (uid: string) => doc(db, 'users', uid);

export async function getUserDoc(uid: string): Promise<UserDoc | null> {
  const snap = await getDoc(userRef(uid));
  return snap.exists() ? (snap.data() as UserDoc) : null;
}

async function createUserDoc(uid: string, data: UserDoc): Promise<void> {
  await setDoc(userRef(uid), { ...data, createdAt: serverTimestamp() });
}

export async function updateUserFields(
  uid: string,
  fields: Partial<UserDoc>,
): Promise<void> {
  await updateDoc(userRef(uid), fields as Record<string, unknown>);
}

export async function ensureDefaultUserDoc(
  uid: string,
  email: string,
): Promise<UserDoc> {
  const existing = await getUserDoc(uid);
  if (existing) return existing;
  const defaults: UserDoc = {
    email,
    firstName: '',
    lastName: '',
    mdType: 'cfpc',
    billingAgency: '',
    billingEmail: '',
    mainPlace: '',
    secondaryPlace: '',
    billingType: 'mixte',
  };
  await createUserDoc(uid, defaults);
  return defaults;
}
